import Navbar from "./components/Navbar";
import Hero from "./components/Hero";

export default function Home() {
  return (
    <main className="w-full bg-background-50 text-foreground-950 font-sans">
      <div className="flex flex-col h-screen min-h-[760px]">
        <Navbar />
        <div className="flex-1 min-h-0">
          <Hero />
        </div>
      </div>
    </main>
  );
}